import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import API from "AccountMerge/API";
import { useAccountMerge } from "AccountMerge/AccountMergeContext";
import { motion } from "framer-motion";

import { colors } from "UI/colors";

import NamesList from "./NamesList";

export default function DuplicateFinderContent({ show }) {
  const [state, dispatch] = useAccountMerge();
  const [isExpanded, setIsExpanded] = useState(false);
  const [status, setStatus] = useState("shouldFetch");
  const [isCompleteSet, setIsCompleteSet] = useState(null);
  const duplicates = state.duplicates.filter((dupe) => !dupe.handled);

  useEffect(() => {
    if (!show || status !== "shouldFetch") return;

    API.getDuplicates()
      .post()
      .then((res) => {
        setStatus("success");
        setIsCompleteSet(res.isCompleteSet);

        const duplicatesWithHandledFlag = res.duplicates.map((dupe) => ({
          ...dupe,
          handled: false,
        }));

        dispatch({
          type: "duplicates",
          payload: duplicatesWithHandledFlag,
        });
      })
      .catch((e) => {
        setStatus("error");
      });
  }, [show, status, dispatch]);

  const getMessage = () => {
    if (!isCompleteSet) return "We found some duplicate profiles.";
    else if (duplicates.length === 1) return `We found 1 duplicate profile.`;
    else return `We found ${duplicates.length} duplicate profiles.`;
  };

  if (!duplicates.length) return null;

  return (
    <>
      <Wrapper
        initial={{ height: 70 }}
        animate={{ height: isExpanded ? "auto" : 70 }}
      >
        <Main onClick={() => setIsExpanded(!isExpanded)}>
          <Left>
            <Icon>
              <span className="fad fa-user-friends" />
            </Icon>
            <Text>{getMessage()}</Text>
          </Left>
          <Right>
            <Arrow animate={{ rotate: isExpanded ? -90 : 0 }}>
              <FontAwesomeIcon icon={faChevronRight} />
            </Arrow>
          </Right>
        </Main>

        <NamesList data={duplicates} isExpanded={isExpanded} />
      </Wrapper>
    </>
  );
}

const Wrapper = styled(motion.div)`
  background-color: white;
  border-radius: 12px;
  margin-bottom: 20px;
  padding: 2px;
  overflow: hidden;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.05);
`;

const Main = styled.div`
  padding: 13px 10px 13px 9px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 10px;
  transition: background 200ms;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
`;

const Icon = styled.div`
  margin-right: 12px;
  font-size: 21px;
  color: white;
  background-color: ${colors.fnPurple};
  border-radius: 100%;
  height: 44px;
  width: 44px;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Text = styled.div`
  color: #2f3f4f;
  font-weight: 500;
`;

const Arrow = styled(motion.div)`
  font-size: 24px;
  width: 28px;
  color: ${colors.fnDkBlueGray};
  display: flex;
  justify-content: center;
  align-items: center;
`;
